import type React from 'react';

export const cardStyle: React.CSSProperties = {
  background: '#fff',
  border: '1px solid rgba(226, 232, 240, 1)',
  borderRadius: 16,
  padding: 24,
  boxShadow: '0 1px 2px rgba(15, 23, 42, 0.06)',
};

export const SAMPLING_INPUT_STYLE: React.CSSProperties = {
  width: 96,
  borderRadius: 999,
  background: '#e9f3fd',
  border: '1px solid #b3c8ff',
  fontWeight: 700,
  color: '#0046ff',
  textAlign: 'center',
};

export const SAMPLING_READONLY_STYLE: React.CSSProperties = {
  padding: '4px 12px',
  borderRadius: 999,
  background: 'rgba(238, 242, 255, 1)',
  border: '1px solid rgba(199, 210, 254, 1)',
  color: 'rgba(67, 56, 202, 1)',
  fontWeight: 700,
  fontSize: 14,
};

export const DEFAULT_BADGE_STYLE: React.CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 8,
  padding: '6px 10px',
  borderRadius: 12,
  background: '#fff',
  border: '1px solid rgba(226, 232, 240, 1)',
  color: 'rgba(51, 65, 85, 1)',
  fontSize: 12,
  fontWeight: 700,
};

export const OPTION_GRID_STYLE: React.CSSProperties = {
  display: 'grid',
  gridTemplateColumns: 'repeat(5, minmax(0, 1fr))',
  gap: 10,
};

export const OPTION_BUTTON_BASE_STYLE: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  padding: '10px 12px',
  borderRadius: 12,
  background: '#fff',
};

